export const getParsedJson = <T>(
  json: string | undefined | null
): T | undefined | null => (json ? JSON.parse(json) : json as T);
